import React from 'react'
import FlexBox from 'schoolUiComponents/basic/Box/FlexBox'
import { FlexProps } from 'schoolUiComponents/basic/Box/FlexBox/types'
import Text from 'schoolUiComponents/basic/Text'
import GoogleButton from './GoogleButton'
import CleverButton from './CleverButton'
import Box from 'schoolUiComponents/basic/Box'
import { Colors } from 'baseStyles/enums/colors'
import Form from './Form'
import TeacherSignupStyles from '../../style'
import { useTeacherSignupState } from '../../../teacherSignup/state'

const TeacherSignupForm = () => {

  const themeStyles = TeacherSignupStyles();

  const { isUkUser } = useTeacherSignupState();

  const redirectToTermsOfUse = () => {
      window.open("/terms-of-use", "_blank");
  }

  const redirectToPrivacyPolicy = () => {
      window.open("/privacy", "_blank");
  }

  const redirectToParentSignup = () => {
    window.location.href = "/parents/register";
  }

  return (
    <FlexBox fullWidth flex={1} column alignItems={FlexProps.AlignItems.FLEX_START} justifyContent={FlexProps.JustifyContent.CENTER} gap={32} {...themeStyles.signupBlock}>
        <FlexBox fullWidth className='create-account-text' center><Text.H1 center>Create your teacher account</Text.H1></FlexBox>
        <FlexBox fullWidth className='social-login-links signup-page-links' alignStart {...themeStyles.socialCtasBlock}>
            { isUkUser ? null : <GoogleButton /> }
            <CleverButton />
        </FlexBox>

        <FlexBox fullWidth height={12} justifyContent={FlexProps.JustifyContent.SPACE_BETWEEN} alignItems={FlexProps.AlignItems.CENTER}>
          <Box width={`45%`} height={1} backgroundColor={Colors.LIGHT_GREY_1}></Box>
          <Box><Text.SMALL letterSpacing={0.28} color={Colors.LIGHT_GREY_1}>&nbsp;OR&nbsp;</Text.SMALL></Box>
          <Box width={`45%`} height={1} backgroundColor={Colors.LIGHT_GREY_1}></Box>
        </FlexBox>
        
        <Form />

        <FlexBox fullWidth alignItems={FlexProps.AlignItems.CENTER} justifyContent={FlexProps.JustifyContent.CENTER} column margin={`16px 0 0 0`}>
          <FlexBox center fullWidth>
            <Text fullWidth>By Signing up, you agree to our&nbsp;</Text>
            <Box onClick={redirectToTermsOfUse}><Text cta emphasis>terms of use</Text></Box>
            <Text>&nbsp;&&nbsp;</Text>
            <Box onClick={redirectToPrivacyPolicy}><Text cta emphasis>privacy policy</Text></Box>
          </FlexBox>
          <FlexBox margin={`24px 0 0 0`}>
            <Text.H4>Are you a parent?&nbsp;</Text.H4>
            <Box onClick={redirectToParentSignup}><Text.H4 cta>Click here</Text.H4></Box>
            <Text.H4>&nbsp;to sign up.</Text.H4>
          </FlexBox>
        </FlexBox>
    </FlexBox>
  )
}

export default TeacherSignupForm